<form [formGroup]="oldMobileForm">
  @if (oldMobilePhoneStep === 1) {
    <app-return-mobile-phone-details
      [canSellHardwareWithLogistics]="canSellHardwareWithLogisticsClaim"
      [equipmentUpgradeAgreement]="equipmentUpgradeAgreement"
      [numberOfSteps]="numberOfSteps"
      [redemptionId]="redemptionId"
      (navigateToNextStep)="oldMobilePhoneStep = 2"
      (setRedemptionId)="onSetRedemptionId($event)"
      />
  }
  @if (oldMobilePhoneStep === 2) {
    <app-mobile-phone-grading
      [equipmentUpgradeAgreement]="equipmentUpgradeAgreement"
      [gradingQuestions]="gradingQuestions"
      [insuranceEligibility]="insuranceEligibility"
      [isLoadingGradingAnswers]="isLoadingGradingAnswers"
      [numberOfSteps]="numberOfSteps"
      (gradingCompleted)="onGradingCompleted()"
      (navigateToPreviousStep)="oldMobilePhoneStep = 1"
      (resetInsuranceEligibility)="insuranceEligibility = null"
      (sendGradingAnswers)="onSendGradingAnswers($event)"
      />
  }
  @if (oldMobilePhoneStep === 3) {
    <app-mobile-phone-insurance
      [deductibleInfo]="insuranceEligibility.deductibleInfo"
      [isCreatingClaim]="isCreatingClaim"
      (navigateToPreviousStep)="oldMobilePhoneStep = 2"
      (useInsurance)="onUseInsurance($event)"
      />
  }
</form>
